(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .component('patrimoineOccupantsTable', {
        templateUrl: 'partials/patrimoine/patrimoine_occupant_table.html',
          controller: PatrimoineOccupantsController
    })
    .controller('PatrimoineOccupantController', PatrimoineOccupantController);


    function PatrimoineOccupantsController($scope, swif, swifPatrimoineService) {
        'ngInject';
        console.log('init PatrimoineOccupantsController');
        $scope.referentiel = swifPatrimoineService.referentiel.data.referentiel;
        var contentType = $scope.referentiel.contentType;
        $scope.$watch('referentiel.currentItem', watchParent);
        $scope.preModal = preModal;
        $scope.preValidate = preValidate;
        $scope.callback = callback;
        $scope.isSIG = swif.settings.app.features.sigConnector;

        function updateCollection(ref_id) {
            var filter = {};
            swif.data.sortOn(filter, 'name');
            if (ref_id && (contentType === 'patrimoine_site' || contentType === 'site' )) {
                swif.data.addExtraFilter(filter, 'patrimoine', 'site_id', '=', ref_id);
            } else if (ref_id && contentType === 'patrimoine_equipment') {
                swif.data.addExtraFilter(filter, 'patrimoine', 'equipment_id', '=', ref_id);
            }
            swif.collections.createOrUpdate(
                'patrimoine_occupant',
                'patrimoine_occupant',
                filter
            ).then(function (collection) {
                $scope.occupants = collection;
            });
        }
        function watchParent(newV) {
            if (newV) {
                updateCollection(newV.id);
            }
        }
        function preModal(data) {
            $scope.occupants.preModal(data);
            var ct = $scope.referentiel.contentType;
            var mid = swif.settings.getContentType(ct).model;
            data.model._isSite = mid === 'openstc.site';
            data.model._isEqpt = mid === 'openstc.equipment';
            if (data.action.id === 'add') {
                data.model.res_model = mid;
                if (data.model._isSite) {
                    data.model.site_id = [
                        $scope.referentiel.currentItem.id,
                        $scope.referentiel.currentItem.name
                    ];
                } else if (data.model._isEqpt) {
                    data.model.equipment_id = [
                        $scope.referentiel.currentItem.id,
                        $scope.referentiel.currentItem.name
                    ];
                }
            }
        }
        function preValidate(data) {
            return $scope.occupants.preValidate(data);
        }
        function callback(error, data) {
            $scope.occupants.callback(error, data);
        }
    }


    function PatrimoineOccupantController($scope, swif, openbase) {
        'ngInject';
        console.log('init PatrimoineOccupantController');
        $scope.filters = {
            partner: {},
            partner_address: {fields: ['id', 'complete_name', 'partner_id']},
            equipment: {fields:  ['id', 'name', 'complete_name', 'equipment_reference']}
        };
        $scope.formatNameChoices = openbase.utils.selectOneFormatNameChoice;
        $scope.onChangePartner = onChangePartner;
        $scope.onChangePartnerAddress = onChangePartnerAddress;
        function onChangePartnerAddress($value) {
            if ($scope.model.partner_id) {
                return;
            }
            if ($value) {
                if ($value.partner_id) {
                    $scope.model.partner_id = [
                        $value.partner_id[0],
                        $value.partner_id[1]
                    ];
                }
            }
        }
        function onChangePartner($value) {
            var filter = $scope.filters.partner_address;
            swif.data.resetFilterDomain(filter);
            if ($value) {
                swif.data.addFilter(filter, 'partner_id', '=', $value.id);
            }
        }
    }


})();
